import { render, staticRenderFns } from "./SubscriptionDetail.vue?vue&type=template&id=1273ab68&scoped=true"
import script from "./SubscriptionDetail.vue?vue&type=script&lang=js"
export * from "./SubscriptionDetail.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDetail.vue?vue&type=style&index=0&id=1273ab68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1273ab68",
  null
  
)

export default component.exports